import { CollectedServiceInputDataDto } from 'src/app/generated/backend/models';

export class LoadBookingClientAction {
  static readonly type = '[Booking] Load client booking';
  constructor(public customerId: number, public collectedServiceDate: string) {}
}

export class SubmitBookingAction {
  static readonly type = '[Booking] Submit booking';
  constructor(public collectedService: CollectedServiceInputDataDto) {}
}

export class UpdateBookingAction {
  static readonly type = '[Booking] Update booking';
  constructor(public collectedService: CollectedServiceInputDataDto) {}
}

export class DeleteBookingAction {
  static readonly type = '[Booking] Delete booking';
  constructor(public bookingId: number, public startDate: string) {}
}

export class ResetBookingAction {
  static readonly type = '[Booking] Reset booking';
  constructor() {}
}
